import * as types from '../mutations-types'
import {createActionHelpers} from 'vuex-loading'
import {
  updateVehicleCondition,
  fetchDefaultReasons,
  fetchValidStatuses
} from '../../utils/api'

const {startLoading} = createActionHelpers({
  moduleName: 'loading'
})

// STATE
const state = {
  validStatuses: [],
  defaultReasons: []
}

// GETTERS
const getters = {
  validStatuses: state => state.validStatuses,
  defaultReasons: state => state.defaultReasons
}

// ACTIONS
const actions = {
  async updateVehicleCondition({commit, dispatch}, payload) {
    await startLoading(dispatch, 'updateVehicleCondition', () => {
      return updateVehicleCondition(payload)
    })
      .then(response => {
        const data = response.data
        // console.log('updateVehicleCondition: ', data)
        commit(types.UPDATE_STATUS_VEHICLE_DATA, data)
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('UVC', error.response)
          if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('UVC', error)
      })
  },
  async fetchDefaultReasons({commit, dispatch}) {
    await startLoading(dispatch, 'fetchDefaultReasons', () => {
      return fetchDefaultReasons()
    })
      .then(data => {
        // console.log('fetchDefaultReasons ', data.data)
        commit(types.FETCH_DEFAULT_REASONS, data.data)
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('FDR', error.response)
          if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('FDR', error)
      })
  },
  async fetchValidStatuses({commit, dispatch}) {
    await startLoading(dispatch, 'fetchValidStatuses', () => {
      return fetchValidStatuses()
    })
      .then(data => {
        // console.log('fetchValidStatuses ', data.data)
        const validStatuses = data.data
        const index = validStatuses.findIndex(item => item.key === 'no_device')
        if (index !== -1) validStatuses.splice(index, 1)
        commit(types.FETCH_VALID_STATUSES, validStatuses)
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('FVS', error.response)
          if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('FVS', error)
      })
  }
}

// MUTATIONS
const mutations = {
  [types.FETCH_DEFAULT_REASONS](state, data) {
    state.defaultReasons = data
  },
  [types.FETCH_VALID_STATUSES](state, data) {
    state.validStatuses = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicleStatus.js